// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OptionsButton_options-button-container__5QXCz {
  position: relative;
}
.OptionsButton_options-button-container__5QXCz .OptionsButton_tooltip__wWpVe {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  transition: opacity 0.3s, transform 0.3s;
  bottom: 55%;
  left: -50%;
  transform: translateX(-50%) translateY(-10px);
  white-space: normal; /* Allow text wrapping */
  max-width: 200px; /* Set maximum width of the tooltip */
  text-align: center; /* Optional: for better text alignment */
  opacity: 1;
  animation: OptionsButton_rainbow-text__tWjHF 2s linear infinite;
}

@keyframes OptionsButton_rainbow-text__tWjHF {
  0% {
    color: red;
  }
  14% {
    color: orange;
  }
  28% {
    color: yellow;
  }
  42% {
    color: green;
  }
  57% {
    color: blue;
  }
  71% {
    color: indigo;
  }
  85% {
    color: violet;
  }
  100% {
    color: red;
  }
}
.OptionsButton_options-button__qyO7w {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 5px;
  border: none;
  border-radius: 10px;
  --bg-color: #ffffff;
  --hover-bg-color: beige;
  --active-bg-color: orange;
  background-color: var(--bg-color);
  color: #ffffff;
  min-width: 10vw;
  min-height: 1.7vh;
  max-width: 225px;
  box-shadow: inset 0 0 0 0px green;
  transition-duration: 0.5s;
}
.OptionsButton_options-button__qyO7w span {
  display: inline-block;
  height: 3px;
  width: 3px;
  margin: 2px;
  border-radius: 2px;
  color: inherit;
  background-color: currentColor;
}
.OptionsButton_options-button__qyO7w .OptionsButton_tooltip__wWpVe {
  opacity: 1;
  transform: translateY(-10px);
}

.OptionsButton_options-button__qyO7w:hover {
  background-color: var(--hover-bg-color);
  min-width: 12vw;
  min-height: 2.7vh;
  max-width: 225px;
  transition-duration: 0.5s;
  box-shadow: inset 0 0 0 60px yellowgreen;
}
@media screen and (max-width: 900px) {
  .OptionsButton_options-button__qyO7w:hover {
    width: 15vw;
  }
}

.OptionsButton_options-button__qyO7w:active {
  background-color: var(--active-bg-color);
}`, "",{"version":3,"sources":["webpack://./src/Components/OptionsButton/OptionsButton.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAAE;EACE,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;EACA,UAAA;EACA,6CAAA;EACA,mBAAA,EAAA,wBAAA;EACA,gBAAA,EAAA,qCAAA;EACA,kBAAA,EAAA,wCAAA;EACA,UAAA;EACA,+DAAA;AAEJ;;AAGA;EACE;IACE,UAAA;EAAF;EAEA;IACE,aAAA;EAAF;EAEA;IACE,aAAA;EAAF;EAEA;IACE,YAAA;EAAF;EAEA;IACE,WAAA;EAAF;EAEA;IACE,aAAA;EAAF;EAEA;IACE,aAAA;EAAF;EAEA;IACE,UAAA;EAAF;AACF;AAGA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iCAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iCAAA;EACA,yBAAA;AADF;AAGE;EACE,qBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,8BAAA;AADJ;AAIE;EACE,UAAA;EACA,4BAAA;AAFJ;;AAQA;EACE,uCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,wCAAA;AALF;AAQE;EATF;IAUI,WAAA;EALF;AACF;;AAUA;EACE,wCAAA;AAPF","sourcesContent":[".options-button-container {\n  position: relative; // Required for tooltip positioning\n  .tooltip {\n    position: absolute;\n    background-color: rgba(0, 0, 0, 0.8);\n    color: #fff;\n    padding: 5px 10px;\n    border-radius: 5px;\n    transition: opacity 0.3s, transform 0.3s;\n    bottom: 55%; // Position it just above the button\n    left: -50%;\n    transform: translateX(-50%) translateY(-10px);\n    white-space: normal; /* Allow text wrapping */\n    max-width: 200px; /* Set maximum width of the tooltip */\n    text-align: center; /* Optional: for better text alignment */\n    opacity: 1;\n    animation: rainbow-text 2s linear infinite; // Add rainbow animation\n  }\n}\n\n\n@keyframes rainbow-text {\n  0% {\n    color: red;\n  }\n  14% {\n    color: orange;\n  }\n  28% {\n    color: yellow;\n  }\n  42% {\n    color: green;\n  }\n  57% {\n    color: blue;\n  }\n  71% {\n    color: indigo;\n  }\n  85% {\n    color: violet;\n  }\n  100% {\n    color: red;\n  }\n}\n\n.options-button {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin: 5px;\n  border: none;\n  border-radius: 10px;\n  --bg-color: #ffffff;\n  --hover-bg-color: beige;\n  --active-bg-color: orange;\n  background-color: var(--bg-color);\n  color: #ffffff;\n  min-width: 10vw;\n  min-height: 1.7vh;\n  max-width: 225px;\n  box-shadow: inset 0 0 0 0px green;\n  transition-duration: .5s;\n\n  span {\n    display: inline-block;\n    height: 3px;\n    width: 3px;\n    margin: 2px;\n    border-radius: 2px;\n    color: inherit;\n    background-color: currentColor;\n  }\n\n  .tooltip {\n    opacity: 1;\n    transform: translateY(-10px);\n  }\n}\n\n\n\n.options-button:hover {\n  background-color: var(--hover-bg-color);\n  min-width: 12vw;\n  min-height: 2.7vh;\n  max-width: 225px;\n  transition-duration: .5s;\n  box-shadow: inset 0 0 0 60px yellowgreen;\n\n\n  @media screen and (max-width: 900px) {\n    width: calc(15vw);\n }\n\n\n}\n\n.options-button:active {\n  background-color: var(--active-bg-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"options-button-container": `OptionsButton_options-button-container__5QXCz`,
	"tooltip": `OptionsButton_tooltip__wWpVe`,
	"rainbow-text": `OptionsButton_rainbow-text__tWjHF`,
	"options-button": `OptionsButton_options-button__qyO7w`
};
export default ___CSS_LOADER_EXPORT___;
